<template lang="html">
  <div class="upload-logo">
    <div class="upload-logo__item-content">
      <div
        v-if="isDefaultFile"
        :class="[
          'upload-logo__image',
          { 'upload-logo__image_file': companyLogo }
        ]"
      >
        <img :src="companyLogo" />
      </div>

      <div v-if="imgLink && !isDefaultFile" class="upload-logo__image">
        <img :src="imgLink" />
      </div>

      <div
        v-if="!hasFiles"
        class="upload-logo__image upload-logo__image_default"
      ></div>

      <div
        :class="['upload-logo__dragDrop', { 'has-files': hasFiles }]"
        v-if="!companyLogo"
      >
        <input
          type="file"
          name="file"
          id="file"
          class="upload-logo__dragDrop-input"
          accept="image/*"
          @change="filesChange($event.target.files)"
        />

        <div class="upload-logo__description" v-if="!hasFiles">
          <div class="upload-logo__dragDrop-subtitle">
            <span v-if="!hasFiles">{{
              $tr('settings.company.labels.uploadLogo')
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'upload-logo',

    props: ['companyLogo'],

    data() {
      return {
        fileList: null,
        imgLink: null
      };
    },

    methods: {
      filesChange(fileList) {
        this.fileList = fileList;

        const file = fileList[0];

        if (typeof FileReader === 'function') {
          const reader = new FileReader();

          reader.onload = event => {
            this.imgLink = event.target.result;
          };

          reader.readAsDataURL(file);
        }

        this.$emit('logoChange', this.fileList);
      }
    },

    computed: {
      isDefaultFile() {
        if (this.companyLogo && !this.fileList) {
          return true;
        }

        return false;
      },

      hasFiles() {
        return this.fileList || this.isDefaultFile;
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.upload-logo {
  margin-right: auto;
  position: relative;
  box-sizing: border-box;

  &__item-content {
    position: relative;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__dragDrop {
    margin: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #afafaf;
    cursor: pointer;
    transition: background-color 0.7s;
    border: 1px dashed $green;
    color: $green;

    &:hover {
      border-style: solid;
    }

    &-input {
      opacity: 0;
      top: 0;
      left: 0;
      width: 100%;
      position: absolute;
      z-index: 10;
      cursor: pointer;
      box-sizing: border-box;

      &#file {
        height: 100%;
      }
    }

    &-subtitle {
      font-size: 14px;
      text-align: center;
      text-transform: uppercase;
    }

    &.has-files {
      border: 0;
    }
  }

  &__image {
    width: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    &_default {
      height: 140px;
      background: #F4F5F7;
      border-radius: 2px;
      font-size: 15px;
      line-height: 22px;
      color: #9FAAB6;
      padding: 19px;
      box-sizing: border-box;
    }

    &_file {
      width: 180px;
      height: auto;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }

  &__description {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__dragDrop-image {
    font-size: 14px;
    margin-right: 10px;
  }
}
</style>
